import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonContent, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {GeneralService} from '../../services/general.service';
import {AdjustDetailLinesDatesService} from '../../services/adjust-detail-lines-dates.service';
import {GeneralSaveDocumentService} from '../../services/general-save-document.service';
import {PersistDocumentService} from '../../services/persist-document.service';

@Component({
    selector: 'app-opportunity',
    templateUrl: './opportunity.page.html',
    styleUrls: ['./opportunity.page.scss'],
})
export class OpportunityPage implements OnInit {

    @Input() document: DocumentModel;
    @ViewChild('content') content: IonContent;
    documentTemp: DocumentModel;

    constructor(private modalController: ModalController,
                private loki: LokijsService,
                private generalServices: GeneralService,
                private alertController: AlertController,
                private persistDocService: PersistDocumentService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
    }
    
    ionViewDidEnter() {
        this.content.scrollToTop(200);
    }


    listenCustomer(event) {
        this.documentTemp.customer = event;
    }

    cancelOpp() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            this.confirmCancel();
        } else {
            this.modalController.dismiss();
        }
    }

    saveOpp() {
        this.document = JSON.parse(JSON.stringify(this.documentTemp));
        this.persistDocService.persistDocument(this.document);
        this.modalController.dismiss();
        this.generalServices.createToast('Opportunity Saved!');
    }

    async confirmCancel() {
        const alert = await this.alertController.create({
            message: 'Do you want to cancel the Contract?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Okay',
                    handler: () => {
                        this.modalController.dismiss();
                    }
                }
            ]
        });
        await alert.present();
    }
}
